import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "HERO_QUALITY",
  title: defineMessage({ id: "fig.quality.HERO.title", defaultMessage: `Quality` }),
  caption: defineMessage({
    id: "fig.quality.HERO.caption",
    defaultMessage: `Globally, most teachers are trained but in sub-Saharan Africa, the percentage of trained teachers fell gradually from 85% in 2000 to 64% in 2022.`,
  }),
  source: defineMessage({ id: "fig.quality.HERO.source", defaultMessage: `UIS database` }),
};
